// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"dc2b7593","448":"106c0e39","469":"b7d9f6f5","494":"174c4312","550":"4483df04","671":"4f13bb6f","787":"f14f4e90"}[chunkId] + ".chunk.js";
};